import { render } from "./ControlPanelSidebar.vue?vue&type=template&id=2a5b6563&scoped=true"
import script from "./ControlPanelSidebar.vue?vue&type=script&lang=js"
export * from "./ControlPanelSidebar.vue?vue&type=script&lang=js"

import "./ControlPanelSidebar.vue?vue&type=style&index=0&id=2a5b6563&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5b6563"]])

export default __exports__